import { selectAgentModerationInfo } from 'shared/selectors';

import { IState } from '../../../store';

export const selectHasVerifiedDocuments = (state: IState): boolean => {
  const moderationInfo = selectAgentModerationInfo(state);

  return Boolean(moderationInfo?.showUserIdentifiedByDocuments);
};
